export const gradientsDefaults = {
  '/': { angle: 230, color1: '#aeb6bd', color2: '#f8f5ff', x: 15, y: 130 },
  '/about': { angle: 250, color1: '#818c93', color2: '#f8f5ff', x: 30, y: 250 },
  '/explore': { angle: 240, color1: '#818c93', color2: '#f8f5ff', x: 15, y: 60 },
  '/tour-detail': { angle: 220, color1: '#5938a6', color2: '#5938a6', x: 30, y: 80 },
  '/tour-navigation': { angle: 220, color1: '#5938a6', color2: '#5938a6', x: 30, y: 80 },
  '/tour-checkout': { angle: 180, color1: '#5938a6', color2: '#5938a6', x: 40, y: 65 },
  '/studio': { angle: 140, color1: '#1f1634', color2: '#301c5d', x: 50, y: 170 },
  '/account': { angle: 110, color1: '#6b7692', color2: '#f6f9ff', x: 80, y: 450 },
  '/login': { angle: 180, color1: '#bfaaef', color2: '#5938a6', x: 30, y: 360 },
  '/signup': { angle: 180, color1: '#45adf5', color2: '#5938a6', x: 30, y: 360 },
  '/request-password-reset': { angle: 90, color1: '#492f87', color2: '#2a1559', x: 50, y: 480 },
  '/studio/tours': { angle: 100, color1: '#d5d5d5', color2: '#d5d5d5', x: 30, y: 50 }
}
